<template lang="pug">
	.campaign-list.tb-padding
		ListView.full-width(ref="listView", initialView="table", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="() => items", :getData="loadCampaigns", :columns="columns")
			template(v-slot:name-cell-template="{ data }")
				a(@click="editCampaign(data)")
					.flex-row.space.align-center
						i.fas.fa-pen-square
						span {{data.Name}}
			template(slot="left-actions")
				.flex-row.space.align-center
					.font-large {{type == 0 ? this.$tCaption('Proposals') : this.$tCaption('Campaigns')}}
					DxButton(icon="plus", @click="addNewRow")
			template(v-slot:percentage="{ data }")
				.flex-col.center.align-center
					.text.font-tiny {{data.TrafficSpotsAired}} ({{data.Percentage}}%)
					.percent-line.flex-row.center.align-center(:style="{ '--percentage': `${data.Percentage}%` }")
						.bar
			template(v-slot:actions-cell-template="{ data }")
				DxDropDownButton(v-if="getActions(data).length", icon="more", :items="getActions(data)", stylingMode="text",  display-expr="name", key-expr="id", :use-select-mode="false", :showArrowIcon="false", 
					:drop-down-options="{ width: 230 }", @item-click="e => onActionClick(e, data)")
		.add-button
			DxButton(icon="plus", type="default", @click="addNewRow")
		NewCampaignDialog(ref="newCampaignDialog", :type="type")
		CampaignVastLink(ref="vastLink")
</template>

<script>
import Data from 'app-core/Data';
import ListView from 'app-core/ListView.vue';
import DxButton from 'devextreme-vue/button';
import NewCampaignDialog from './NewCampaignDialog.vue';
import CampaignVastLink from './CampaignVastLink.vue';
import DxDropDownButton from 'devextreme-vue/drop-down-button';

export default {
	translationCategory: 'campaign.List',
	components: { ListView, DxButton, NewCampaignDialog, CampaignVastLink, DxDropDownButton },
	props: ['type'],
	data() {
		return {
			result: null,
			actions: [
				{ id: 'vast', name: this.$tCaption('Get VAST Tag'), icon: 'fas fa-copy' },
			],
		};
	},
	computed: {
		items() {
			return this.result && this.result.Results.map(f => ({
				...f,
				AdvertiserName: f.Advertiser && f.Advertiser.Name,
				AgencyName: f.Agency && f.Agency.Name
			}));
		},
		columns() {
			const baseColumns = [
				{ dataField: 'Name', caption: () => this.$tCaption('Name'), cellTemplate: 'name-cell-template' },
				{ dataField: 'StartDate', caption: () => this.$tCaption('Start date'), dataType: 'date', sortIndex: 0, sortOrder: 'desc' },
				{ dataField: 'EndDate', caption: () => this.$tCaption('End date'), dataType: 'date', sortIndex: 1, sortOrder: 'desc' },
				{ dataField: 'AdvertiserName', caption: () => this.$tCaption('Advertiser name') },
				{ dataField: 'AgencyName', caption: () => this.$tCaption('Agency name') },
			];
			if (this.type === 1) {
				return [
					...baseColumns,
					{ dataField: 'TotalTargetImpressions', caption: () => this.$tCaption('Impressions'), format: 'fixedPoint' },
					{ dataField: 'TotalTargetGrps', caption: () => this.$tCaption('GRPs'), format: 'fixedPoint' },
					{ dataField: 'TotalTargetAirTimeSpots', caption: () => this.$tCaption('Airtime spots'), format: 'fixedPoint' },
					{ dataField: 'Percentage', name: 'Percentage', caption: () => this.$tCaption('Delivered/aired'), cellTemplate: 'percentage' },
					{ dataField: 'Name', name: 'Actions', cellTemplate: 'actions-cell-template', caption: '', width: 80 }
				];
			} else {
				return baseColumns;
			}
		}
	},
	watch: {
		type() {
			this.$refs.listView.reload({ clear: true });
		}
	},
	mounted() {
		if (__DEBUG__)
			window.campaignsList = this;
	},
	methods: {
		onActionClick(e, campaign) {
			switch(e.itemData.id) {
				case 'vast':
					this.$refs.vastLink.open(campaign.Oid);
					break;
			}
		},
		getActions(campaign) {
			return this.actions.filter(f => !f.hidden || !f.hidden(campaign));
		},
		loadCampaigns(pageIndex, size, opts) {
			const type = this.type;
			return Data.getExternalCampaigns(pageIndex, size, { ...(opts || {}), type: this.type }).then(r => {
				if (type !== this.type) return [];
				if (__DEBUG__)
					console.debug('Campaigns loaded', { r });
				r.Results.map(f => {
					f.Percentage = ((r.TotalDeliveredAirTimeSpots || 0) + (r.TotalDeliveredGrps || 0) + (r.TotalDeliveredImpressions || 0)) / ((r.TotalTargetAirTimeSpots || 0) + (r.TotalTargetGrps || 0) + (r.TotalTargetImpressions || 0)) || 0;
				});
				this.result = r;
				return r;
			});
		},
		addNewRow(){
			this.$refs.newCampaignDialog.show();
		},
		editCampaign(data) {
			if (__DEBUG__)
				console.debug('Edit campaign', data);
			this.$router.push({ name: 'campaign-detail', params: { id: data.Oid } });
		}
	}
};
</script>
<style lang="scss">
	.campaign-list {
		position: relative;

		.add-button {
			position: fixed;
			display: flex;
			align-items: center;
			justify-content: center;
			bottom: 40px;
			right: 40px;
			border-radius: 100px;
			width: 40px;
			height: 40px;
		}

		.percent-line {
			background: #efefef;
			border-radius: 8px;
			position: relative;
			width: 100%;
			height: 6px;

			> .bar {
				position: absolute;
				left: 0px;
				top: 0px;
				height: 100%;
				border-radius: 8px;
				background: #33cc33;
				width: var(--percentage);
				z-index: 0;
			}

			> .text {
				z-index: 1;
			}
		}
	}
</style>
